export default [
    {
        id: 1, // 推送到个人的消息ID，跟另外一个ID不一样
        subject: '消息1',
        content: '内容1',
        timestamp: new Date('2020-08-31 10:00:00'), // 推送的时间，也是该消息生成的时间
        status: 'UNREAD', // 状态 [read, unread] -> [已读，未读]
        indexNotif: new Date('2020-08-31 17:00:00') // 首页显示截止日期
    },
    {
        id: 2,
        subject: '消息2',
        content: '内容2',
        timestamp: new Date('2020-08-30 10:00:00'),
        status: 'UNREAD',
        indexNotif: new Date('2020-08-31 17:00:00')
    },
    {
        id: 3,
        subject: '消息3',
        content: '内容3',
        timestamp: new Date('2020-08-31 10:30:00'),
        status: 'UNREAD',
        indexNotif: null
    },
    {
        id: 4,
        subject: '消息4',
        content: '内容4',
        timestamp: new Date('2020-08-29 10:00:00'),
        status: 'READ',
        indexNotif: new Date('2020-08-31 10:00:00')
    },
    {
        id: 5,
        subject: '消息5',
        content: '内容5',
        timestamp: new Date('2020-08-29 10:00:00'),
        status: 'READ',
        indexNotif: new Date('2020-09-31 10:00:00')
    },
]